import React from 'react';

import { Card } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import CircularButtonDropdown from '@src/components/CircularDropdown';

import styles from './styles.module.less';
function DashboardCard({ children, className, title, subTitle, actionButtons, downloading, highlighted }) {
  return (
    <Card className={classNames(styles.card, className, { [styles.highlighted]: highlighted })}>
      <div className="gx-d-flex gx-flex-column gx-h-100">
        <div className={styles.topContainer}>
          <div className="gx-d-flex gx-flex-column">
            <div className="gx-d-flex gx-flex-row gx-align-items-center gx-guarnic-gap-1 gx-flex-nowrap">
              <div className="drag-handle" style={{ cursor: 'grab' }}>
                <span class="material-symbols-outlined">drag_indicator</span>
              </div>
              {title && <span className={styles.title}>{title}</span>}
            </div>
            {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
          </div>
          {actionButtons?.length > 0 && (
            <div className={classNames('cancelDrag', styles.dashboardCardButtons)}>
              <CircularButtonDropdown
                triggerType="primary"
                triggerIconName="more_horiz"
                options={actionButtons}
              />
            </div>
          )}
        </div>
        <div className={classNames(styles.contentWrapper, { [styles.downloading]: downloading })}>
          {children}
        </div>
      </div>
    </Card>
  );
}

DashboardCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  downloading: PropTypes.bool,
  highlighted: PropTypes.bool,
  actionButtons: PropTypes.arrayOf(
    PropTypes.shape({
      iconName: PropTypes.string,
      action: PropTypes.func,
      disabled: PropTypes.bool,
      hidden: PropTypes.bool,
      label: PropTypes.string,
      tooltipText: PropTypes.string,
      type: PropTypes.string,
      iconClassName: PropTypes.string,
      iconNameText: PropTypes.string,
      allowedRole: PropTypes.arrayOf(PropTypes.string),
      divId: PropTypes.string,
    }),
  ),
};

export default React.memo(DashboardCard);
